// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardFolderHeader {
  display: inline;
  display: initial;
}
.DashboardFolderHeader .BreadCrumbs {
  margin-bottom: 24px;
}
.DashboardFolderHeader .BreadCrumbs .BreadCrumb {
  padding: 0px;
}
.DashboardFolderHeader .react-loading-skeleton {
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/modules/dashboard/dashboard-folder-header/dashboard-folder-header.styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EAAA,gBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,YAAA;AACN;AAGE;EACE,mBAAA;AADJ","sourcesContent":[".DashboardFolderHeader {\n  display: initial;\n\n  .BreadCrumbs {\n    margin-bottom: 24px;\n\n    .BreadCrumb {\n      padding: 0px;\n    }\n  }\n\n  .react-loading-skeleton {\n    margin-bottom: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
